export class UserData {
  oid: string;
  tid: string;
  name: string;
  email: string;

  roles: string[] = []

  constructor(oid: string, tid: string, name: string, email: string, roles: string[] = []) {
    this.oid = oid;
    this.tid = tid;
    this.name = name;
    this.email = email;
    this.roles = roles;
  }

  get firstName(): string {
    return this.name.split(',')[1];
  }
}
